export enum Routes {
  General = '/',
  Analytics = '/analytics',
  SmartLinks = '/smart-links',
  Loyalty = '/loyalty',
  Finance = '/finance',
  Prices = '/prices',
  Support = '/support',
  Welcome = '/welcome',
  Releases = '/releases',
  NewRelease = '/releases/new-release/:id?',
  SignIn = '/sign-in',
  SignUp = '/sign-up',
  RecoveryPassword = '/recovery-password',
  SignUpConfirm = '/sign-up-confirm/:id/:token',
  NewPassword = '/new-password',
  RecoveryPasswordCompleted = '/recovery-password-completed',
  ReleaseDetails = '/releases/:id',
  Artists='/artists',
  ArtistsDetails='/artists/:id',
  Labels = '/labels',
  LabelsDetails = '/labels/:id',
  Tracks = '/tracks',
  Authors = '/authors',
  SmartLinkCreation = '/smart-link-creation/:id/new',
  SmartLinkEdit = '/smart-link-creation/:id/edit',
  SelectSmartLink='/select-smart-links',
  SmartLinkAnalytics = '/smart-link-Analytics/:id/',
  Library = '/library',
  AICompose='/ai-compose',
  Song='/song/:uuid?',
  Playlist='/playlist/:uuid?',
}
